import type { BackendRouteDefinition } from '../types';

/**
 * Migrated to `api-core-node` in PRA-798 (Phase 5 / Sub-phase 7 / S7-WB1).
 * The `syncLawPayTransactions` callable is intentionally left in place for
 * rollback until the Sub-phase 9 retirement sweep.
 */
export const syncLawPayTransactionsRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/lawpay/transactions:sync',
} as const satisfies BackendRouteDefinition;
